import AdminFileManager from './fileManager'
import AdminConfig from './config'
import AdminPanel from './panel'
import AdminBrand from './brand'
import AdminTheme from './theme'
import AdminManager from './manager'
import AdminService from './service'
import AdminUnit from './unit'
import AdminUser from './user'
import AdminLanguagePair from './languagePair'
import AdminLanguage from './language'
import AdminCountry from './country'
import AdminCampaign from './campaign'
import AdminTemplate from './template'
import AdminSpecialization from './specialization'
import AdminNotificationGroup from './notification'
import AdminMailQueue from './mailQueue'
import AdminStorage from './storage'
import AdminSMTP from './smtp'
import AdminTag from './tag'
import AdminPriority from './priority'
import AdminWorkingHours from './workingHours'
import AdminTemplateFolder from './templateFolder'

import {
  LAYOUT_ADMIN_PANEL,
  LAYOUT_ADMIN_FILE_MANAGER_ROOT,
  LAYOUT_ADMIN_CONFIG_ROOT,
  LAYOUT_ADMIN_MANAGER_ROOT,
  LAYOUT_ADMIN_USER_ROOT,
  LAYOUT_ADMIN_UNIT_ROOT,
  LAYOUT_ADMIN_SERVICE_ROOT,
  LAYOUT_ADMIN_BRAND_ROOT,
  LAYOUT_ADMIN_THEME_ROOT,
  LAYOUT_ADMIN_TEMPLATE_ROOT,
  LAYOUT_ADMIN_CAMPAIGN_ROOT,
  LAYOUT_ADMIN_SPECIALIZATION_ROOT,
  LAYOUT_ADMIN_LANGUAGE_ROOT,
  LAYOUT_ADMIN_LANGUAGE_PAIR_ROOT,
  LAYOUT_ADMIN_COUNTRY_ROOT,
  LAYOUT_ADMIN_NOTIFICATION_GROUP_ROOT,
  LAYOUT_ADMIN_MAIL_QUEUE_ROOT,
  LAYOUT_ADMIN_SMTP_ROOT,
  LAYOUT_ADMIN_STORAGE_ROOT,
  LAYOUT_ADMIN_TAG_ROOT,
  LAYOUT_ADMIN_PRIORITY_ROOT,
  LAYOUT_ADMIN_WORKING_HOURS_ROOT,
  LAYOUT_ADMIN_TEMPLATE_FOLDER_ROOT
} from './navigation'

const routes = [
  {
    path: LAYOUT_ADMIN_CONFIG_ROOT,
    component: AdminConfig,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_PANEL,
    component: AdminPanel,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_BRAND_ROOT,
    component: AdminBrand,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_THEME_ROOT,
    component: AdminTheme,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_MANAGER_ROOT,
    component: AdminManager,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_SERVICE_ROOT,
    component: AdminService,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_UNIT_ROOT,
    component: AdminUnit,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_USER_ROOT,
    component: AdminUser,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_FILE_MANAGER_ROOT,
    component: AdminFileManager,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },

  {
    path: LAYOUT_ADMIN_LANGUAGE_PAIR_ROOT,
    component: AdminLanguagePair,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_LANGUAGE_ROOT,
    component: AdminLanguage,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_COUNTRY_ROOT,
    component: AdminCountry,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_CAMPAIGN_ROOT,
    component: AdminCampaign,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_TEMPLATE_ROOT,
    component: AdminTemplate,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_SPECIALIZATION_ROOT,
    component: AdminSpecialization,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_NOTIFICATION_GROUP_ROOT,
    component: AdminNotificationGroup,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },

  {
    path: LAYOUT_ADMIN_MAIL_QUEUE_ROOT,
    component: AdminMailQueue,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_SMTP_ROOT,
    component: AdminSMTP,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_STORAGE_ROOT,
    component: AdminStorage,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_TAG_ROOT,
    component: AdminTag,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_PRIORITY_ROOT,
    component: AdminPriority,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_WORKING_HOURS_ROOT,
    component: AdminWorkingHours,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  },
  {
    path: LAYOUT_ADMIN_TEMPLATE_FOLDER_ROOT,
    component: AdminTemplateFolder,
    allowToOneOf: ['ROLE_MANAGER_ADMIN']
  }
]

export default routes
